module.exports = __webpack_public_path__ + "assets/img/046101.8a7bc73a.png";